import React, { ReactNode } from "react";
import { motion } from "framer-motion";
import NavbarOther from "../components/NavbarOther";
import Policy from "./sections/Policy";
import Footer from "../components/Footer";

interface SectionWrapperProps {
  children: ReactNode;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children }) => (
  <motion.section
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
  >
    {children}
  </motion.section>
);

const Privacy = () => {
  return (
    <div style={{ width: "100%" }}>
      <SectionWrapper>
        <NavbarOther />
      </SectionWrapper>

      <SectionWrapper>
        <Policy />
      </SectionWrapper>

      <SectionWrapper>
        <Footer />
      </SectionWrapper>
    </div>
  );
};

export default Privacy;
